import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IQuoteServiceVariableState } from './quote-service-variable.types';
import { IQuoteServiceVariableData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IQuoteServiceVariableState = {
  version: 1,
  quoteServiceVariables: [] as IQuoteServiceVariableData[]
};

const namespaced = true;

export const quoteServiceVariable: Module<
  IQuoteServiceVariableState,
  IRootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
